import React, { ReactElement } from 'react';

import {
  Business,
  Home,
  Store,
} from "@mui/icons-material";
import { mobiliTheme } from "../themes/mobiliTheme";

export const visitTypeMapping: { [key: string]: string } = {
  Heim: "HM",
  Haus: "HB",
  Praxis: "PX",
  // Add more mappings as needed
};

// Mapping of visitType to icons
export const visitTypeToIcon: Record<string, ReactElement> = {
  haus: <Home sx={{color:mobiliTheme.mainHeader}}/>,
  praxis: <Store sx={{color:mobiliTheme.mainHeader}}/>,
  heim: <Business sx={{color:mobiliTheme.mainHeader}}/>,
};

// Function mapping of visitType to icons with color param
export const getVisitTypeIcon = (
  type: string,
  color: string = mobiliTheme.mainHeader
): ReactElement | null => {
  const icons: Record<string, ReactElement> = {
    haus: <Home sx={{ color }} />,
    praxis: <Store sx={{ color }} />,
    heim: <Business sx={{ color }} />,
  };

  return icons[type?.toLowerCase()] ?? null;
};
